import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Route, Link } from "react-router-dom";

// Containers
import Login from "../components/Login/Login";
import LoginWithUsername from "../components/Login/LoginWithUsername";
import Page404 from "./Page404";
import Page500 from "./Page500";
import Home from "./Home";

// Components
import Header from "../components/Header/Header";
import ActivityIndicator from "../components/ActivityIndicator/ActivityIndicator";
import Sidebar from "../components/Sidebar/Sidebar";
import Footer from "../components/Footer/Footer";
import Overlay from "../components/Sidebar/Overlay";
import SplashScreen from "../components/SplashScreen/SplashScreen";
import BottomMobileMenu from "../components/BottomMobileMenu/BottomMobileMenu";

import { showSplash } from "../actions/SplashScreenActions";

import CookieConsent from "react-cookie-consent";

import { detect } from "detect-browser";
import { config } from "../constants/domainConfig";
import { getText } from "../constants/multiDomains";

const browser = detect();
const frenchDomain = config.lang == "fr" ? true : false;
const englishDomain = config.lang == "en" ? true : false;
const belgiumDomain = config.lang == "be" ? true : false;
const germanDomain = config.lang == "de" ? true : false;
const turkeyDomain = config.lang == "tr" ? true : false;
const ptDomain = config.lang == "pt" ? true : false;
const rsDomain = config.lang == "cy" ? true : false;
const eeDomain = config.lang == "ee" ? true : false;
const thDomain = config.lang == "th" ? true : false;
const egDomain = config.domain == "eg" ? true : false;
const esDomain = config.lang == "es" ? true : false;
const idDomain = config.lang == "id" ? true : false;
const beDomain = config.domain == "be" ? true : false;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feedbackModal: false,
      modal: false,
    };
    this.showSearch = this.showSearch.bind(this);
    this.showMenu = this.showMenu.bind(this);
    this.hideHomeRoute = this.hideHomeRoute.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  componentWillMount() {}

  showSearch() {
    let hideSearchRoute = [];
    if (window.innerWidth <= 575) {
      hideSearchRoute = [
        "welcome",
        "show",
        "play",
        "videos",
        "account",
        "movies",
        "about",
        "category",
        "terms-conditions",
        "privacy-policy",
        "smartTv",
        "all",
        "history",
        "claim-gadget",
        "panoramic",
        "panoramic-show",
        "ContactUs",
      ];
    } else {
      hideSearchRoute = [
        "welcome",
        "account",
        "about",
        "terms-conditions",
        "privacy-policy",
        "smartTv",
        "all",
        "history",
        "panoramic",
        "panoramic-show",
        "ContactUs",
      ];
    }
    let pathname = this.props.location.pathname.split("/")[1];
    if (~hideSearchRoute.indexOf(pathname)) {
      return false;
    }

    return true;
  }

  showMenu() {
    let hideMenuRoute = [];
    if (window.innerWidth <= 575) {
      hideMenuRoute = [
        "welcome",
        "category",
        "account",
        "history",
        "claim-gadget",
      ];
    } else {
      hideMenuRoute = ["welcome", "category"];
    }
    let pathname = this.props.location.pathname.split("/")[1];
    if (~hideMenuRoute.indexOf(pathname)) {
      return true;
    }

    return false;
  }

  hideHomeRoute() {
    let hideHomeRoute = ["login", "404", "500", "restricted", "welcome"],
      pathname = this.props.location.pathname.split("/")[1];
    if (~hideHomeRoute.indexOf(pathname)) {
      return false;
    }
    return true;
  }

  showBottomMenu() {
    let hideBottomMenuRoute = [
        "welcome",
        "category",
        "account",
        "history",
        "claim-gadget",
      ],
      pathname = this.props.location.pathname.split("/")[1];
    if (~hideBottomMenuRoute.indexOf(pathname)) {
      document.body.classList.add("bottom-menu-active");
      return true;
    } else {
      document.body.classList.remove("bottom-menu-active");
    }

    return false;
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
    });
  }

  render() {
    console.log("config", config);
    let routes_align_center = [
        "/login",
        "/404",
        "/500",
        "/restricted",
        "/about",
      ],
      app_body_class =
        routes_align_center.indexOf(this.props.location.pathname) == -1
          ? "app-body flex-column"
          : "app-body flex-row align-items-center";
    if (browser.os === "Android OS" || browser.os === "ios") {
      if (
        (browser.name === "chrome" && parseInt(browser.version) < 51) ||
        (browser.name === "ie" && parseInt(browser.version) < 10) ||
        (browser.name === "firefox" && parseInt(browser.version) < 52) ||
        (browser.name === "safari" && parseInt(browser.version) < 7) ||
        (browser.name === "edge" && parseInt(browser.version) < 10) ||
        (browser.name === "opera" && parseInt(browser.version) < 16)
      ) {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
              width: "100%",
            }}
          >
            <div
              style={{
                height: "20vh",
                width: "100%",
                flexDirection: "column",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "red",
              }}
            >
              <h3>
                {" "}
                {browser.name} (version: {browser.version}) unsupported
              </h3>
              <h4>Please download latest browser version. </h4>
            </div>
          </div>
        );
      }
    }

    if (!this.props.splash.hideSplash || this.props.location.pathname === "/") {
      return <Route name="Splash Screen" component={SplashScreen} />;
    } else {
      let cookieMsg, moreInfo, btnText, to;
      if (config.lang === "fr") {
        cookieMsg =
          "Salut! Notre site Web utilise des cookies pour vous garantir la meilleure expérience possible avec Mobio360.";
        moreInfo = "Plus d'informations";
        btnText = "Je l'ai!";
        to = "/privacy-policy";
      } else if (config.lang === "be") {
        cookieMsg =
          "Onze website maakt gebruik van cookies om ervoor te zorgen dat u de best mogelijke ervaring met touchnote krijgt.";
        moreInfo = "Meer informatie";
        btnText = "Begrijp ik!";
        to = "/privacy-policy";
      } else if (turkeyDomain) {
        cookieMsg =
          "Merhaba! Web sitemiz, touchnote ile mümkün olan en iyi deneyimi elde etmek için çerezleri kullanır.";
        moreInfo = "Daha fazla bilgi";
        btnText = "Anladım!";
        to = "/privacy-policy";
      } else if (config.lang === "de") {
        cookieMsg =
          "Hi! Unsere Website verwendet Cookies, um dir garantiert die bestmögliche Erfahrung mit Mobio360 zu bieten.";
        moreInfo = "Mehr Info";
        btnText = "Ich habs!";
        to = "/privacy-policy";
      } else if (config.lang === "el") {
        cookieMsg =
          "Γεια σας! Ο ιστότοπός μας χρησιμοποιεί cookies για να διασφαλίσουμε ότι θα έχετε την καλύτερη δυνατή εμπειρία με το Mobio360.";
        moreInfo = "περισσότερες πληροφορίες";
        btnText = "Το κατάλαβα!";
        to = "/privacy-policy";
      } else if (config.lang === "it") {
        cookieMsg =
          "Ciao! Il nostro sito web usa i cookie per garantire la migliore esperienza possibile con Mobio360.";
        moreInfo = "maggiori informazioni";
        btnText = "Capito!";
        to = "/privacy-policy";
      } else if (ptDomain) {
        cookieMsg =
          "Ao utilizar qualquer dos nossos Serviços, concorda com a nossa recolha e utilização da sua informação em conformidade com a nossa Política de Privacidade.";
        moreInfo = "Para obter mais informação";
        btnText = "Entendi";
        to = "/privacy-policy";
      } else if (config.domain == "no") {
        cookieMsg =
          "Hei! Nettsiden vår bruker informasjonskapsler for å sikre at du får best mulig opplevelse med Mobio360.";
        moreInfo = "Mer info";
        btnText = "Skjønner!";
        to = "/privacy-policy";
      } else if (config.lang == "ar") {
        cookieMsg = `مرحبا! يستخدم موقعنا ملفات تعريف الارتباط لضمان حصولك على أفضل تجربة ممكنة مع ${getText()}`;
        moreInfo = "مزيد من المعلومات";
        btnText = "فهمتك";
        to = "/privacy-policy";
      } else if (rsDomain) {
        cookieMsg =
          "Ћао! Наша веб локација користи колачиће како би осигурала најбоље могуће искуство на Mobio360";
        moreInfo = "више информација";
        btnText = "разумем";
        to = "/privacy-policy";
      } else if (eeDomain) {
        cookieMsg =
          "Tere! Meie veebisait kasutab küpsiseid, et tagada sulle  Mobio360-ga võimalikult hea kogemus.";
        moreInfo = "rohkem infot";
        btnText = "Sain aru!";
        to = "/privacy-policy";
      } else if (thDomain) {
        cookieMsg =
          "สวัสดี! เว็บไซต์ของเราปรับใช้คุกกี้เพื่อให้คุณได้รับประสบการณ์ที่ดีที่สุดในการใช้งานครับ ${getText()}.";
        moreInfo = "ข้อมูลเพิ่มเติม";
        btnText = "เข้าใจแล้ว!";
        to = "/privacy-policy";  
      } else if (esDomain) {
        (cookieMsg =
          "¡Hola! Nuestro sitio web utiliza cookies para asegurarse de que obtiene la mejor experiencia posible con Mobio360."),
          (moreInfo = "Más información");
        btnText = "¡Entendido!";
        to = "/privacy-policy";
      } else if (idDomain) {
        (cookieMsg =
          "Hai! Situs web kami menggunakan cookie untuk memastikan Anda mendapatkan pengalaman terbaik dengan Mobio360."),
          (moreInfo = "Info lebih lanjut");
        btnText = "Mengerti!";
        to = "/privacy-policy";
      } else if (config.lang === "si") {
        (cookieMsg =
          "Pozdravljeni! Naše spletno mesto uporablja piškotke, da vam zagotovi najboljšo možno izkušnjo z Vibe360."),
          (moreInfo = "več informacij");
        btnText = "Razumem!";
        to = "/privacy-policy";
      } else if (config.lang === "pl") {
        cookieMsg = `Cześć! Nasza strona używa plików cookie, aby zapewnić Ci najlepsze możliwe doświadczenie z ${getText()}.`;
        moreInfo = "więcej informacji";
        btnText = "Rozumiem!";
        to = "/privacy-policy";
      } else {
        cookieMsg = `Hi! Our website uses cookies to ensure you get the best possible experience with ${getText()}.`;
        moreInfo = "more info";
        btnText = "Got it!";
        to = "/privacy-policy";
      }
      const privacyLinkNonEnglish = {
        ci: "http://n.mobi360vr.com/ci/tnc-mobio360?offer=1&_next=privacy_policy.html",
        cm: "http://n.mobi360vr.com/cm/tnc-mobio360?offer=1&_next=privacy_policy.html",
        sn: "http://n.mobi360vr.com/sn/tnc-mobio360?offer=1&_next=privacy_policy.html",
        cd: "http://n.mobi360vr.com/cd/tnc-mobio360?offer=1&_next=privacy_policy.html",
        tn: "http://n.mobi360vr.com/tn/tnc-mobio360?offer=1&operator=TN_ORANGE&operatorSubmitted=Y&_next=privacy_policy.html",
        be: "http://n.mobi360vr.com/be/tnc-mobio360?offer=1&_next=general_conditions.html",
      };

      return (
        <div className="app">
          <div>
            <CookieConsent
              location="bottom"
              buttonText={btnText}
              cookieName="Mobio360Cookie"
              style={{ background: "#2B373B" }}
              buttonStyle={{
                backgroundColor: "white",
                fontSize: "13px",
                margin: "5px",
                marginRight: `${
                  config.domain === "ae" || config.domain === "demo"
                    ? "10%"
                    : "5px"
                }`,
              }}
            >
              {cookieMsg}{" "}
              {Object.keys(privacyLinkNonEnglish).indexOf(config.domain) < 0 ? (
                <Link to={to}>
                  <p style={{ color: "skyblue" }}>{moreInfo}</p>
                </Link>
              ) : (
                <Link
                  onClick={(e) =>
                    (window.location = privacyLinkNonEnglish[config.domain])
                  }
                  to={""}
                >
                  <p style={{ color: "skyblue" }}>{moreInfo}</p>
                </Link>
              )}
            </CookieConsent>
          </div>

          <Route path="/login" name="Login Page" component={Login}></Route>
          <Route
            path="/loginWithUsername"
            component={LoginWithUsername}
          ></Route>
          {this.props.location.pathname.split("/")[1] == "login" ||
          this.props.location.pathname.split("/")[1] == "loginWithUsername" ? (
            ""
          ) : (
            <Header
              isAdmin={this.props.user.isAdmin}
              showSearch={this.showSearch()}
              showMenu={this.showMenu()}
              {...this.props}
              changeLang={this.props.changeLang}
            />
          )}

          {window.innerWidth <= 575 ? (
            <BottomMobileMenu
              showBottomMenu={this.showBottomMenu()}
              changeLang={this.props.changeLang}
            />
          ) : (
            <Sidebar
              isAdmin={this.props.user.isAdmin}
              changeLang={this.props.changeLang}
            />
          )}
          <div className={app_body_class}>
            <Route path="/404" name="Page 404" component={Page404} />
            <Route path="/500" name="Page 500" component={Page500} />
            <Route name="Home" component={Home} />
            {ptDomain || eeDomain || egDomain || config.domain === "za" ? (
              <Footer />
            ) : (
              ""
            )}
          </div>
          <Overlay isAdmin={this.props.user.isAdmin} />
          <ActivityIndicator isLoading={this.props.loader.isLoading} />
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    search: state.SearchReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      showSplash,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App.js